import Layout from "../include/layout";
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import { useEffect, useState } from "react";
import $ from "jquery"
import Swal from "sweetalert2";
import dayjs from "dayjs";
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.css'
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import ContactsService from "../../services/ContactsService";
import { useSelector } from "react-redux";

export default function IndexContacts() {

    //##########################/// METHODES ##########################///
    const [contacts, setContacts] = useState([])
    const token = useSelector(state => state.auth.token)

    //get liste
    const fetchContacts = async () => {
        await ContactsService.index(token).then((res) => {
            setContacts(res.data.contacts)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }

    //Modal de detail
    const [showContact, setShowContact] = useState(false);
    const [sujet, setSujet] = useState('')
    const [message, setMessage] = useState('')

    const handleClose = () => setShowContact(false);
    const handleShow = (sujet, message) => {
        setSujet(sujet)
        setMessage(message)
        setShowContact(true);
    }


    useEffect(() => {
        fetchContacts()
        $("#submenu-6").addClass("show")
    }, []) //Le crochet vide indique à React d'exécuter l'effet uen seule fois

    //##########################/// END METHODES ##########################///


    return (
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0">Contacts</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item active">Liste des contacts </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Liste des contacts</h1>
                        </div>
                    </div>{/*//row*/}

                    <div className="app-card app-card-orders-table shadow-lg mb-5">
                        <div className="app-card-body mx-3 py-2">
                            <div className="table-responsive mt-4">
                                <table className="table table-borderless table-hover app-table-hover mb-0 text-left data-table">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className=" text-white">N°</th>
                                            <th className=" text-white">Nom </th>
                                            <th className=" text-white">Email</th>
                                            <th className=" text-white">Telephone</th>
                                            <th className=" text-white">Pays</th>
                                            <th className=" text-white">Date recep.</th>
                                            <th className=" text-white">Statuts</th>
                                            <th className=" text-white">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-group-divider" style={{ textAlign: "left" }}>
                                        {contacts.length > 0 && contacts.map((item, index) => (
                                            <tr key={index}>
                                                <td className="">{index + 1}</td>
                                                <td className="">{item.nom}</td>
                                                <td className="">{item.email}</td>
                                                <td className="">{item.telephone}</td>
                                                <td className="">{item.get_pays.nom_pays}</td>
                                                <td className=""><span>{dayjs(item.created_at).format("DD/MM/YYYY H:m:s")}</span></td>
                                                <td className=""><span className={(item.get_statut.libelle === "ACTIF") ? "badge bg-success" : "badge bg-danger"}>{item.get_statut.libelle}</span></td>
                                                <td className="d-flex justify-content-center">
                                                    <Button className="btn btn-sm btn-success" onClick={() => handleShow(item.sujet, item.message)} title="Détails">
                                                        <i className="fas fa-list"></i></Button>
                                                </td>

                                                <Modal show={showContact} onHide={handleClose} centered>
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>Détails du mail</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <Row>
                                                            <Col md={12} sm={12} className="form-group">
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Sujet <i className="text-danger"></i>
                                                                    </Form.Label>
                                                                    <Form.Control className="border border-info border rounded-2"
                                                                        value={sujet}
                                                                        placeholder="Sujet"
                                                                        name="Sujet"
                                                                        aria-label="Sujet"
                                                                        maxLength={100}
                                                                        minLength={3}
                                                                        type="text"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>

                                                        <Row>
                                                            <Col md={12} sm={12} className="form-group">
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Message  <i className="text-danger"></i>
                                                                    </Form.Label>
                                                                    <textarea value={message} readOnly disabled name="message" id="" cols="30" rows="5" className="form-control summernote border border-info border rounded-2" placeholder=""></textarea>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Form.Group className="text-center py-3">                                                            
                                                            <Button variant="dark" onClick={handleClose} className="mx-4">
                                                                Fermer
                                                            </Button>
                                                        </Form.Group>
                                                    </Modal.Body>
                                                </Modal>

                                            </tr>
                                        ))}


                                    </tbody>
                                </table>
                            </div>{/*//table-responsive*/}

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                    {/*//End table-content*/}



                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}